import { QueryClient } from '@tanstack/react-query';
import {
  BulkUpdateDocumentDto,
  DocumentColumnMaxValuesDto,
  UpdateDocumentDto,
} from '@sib/api';
import { QueryKey } from '@sib/api/enums';
import { BasePagedApiResponse } from '@sib/api/types';

type ItemWithId = {
  id: string;
};

interface UpdateInListCacheParams<TItem extends ItemWithId> {
  old?: BasePagedApiResponse<TItem>;
  id: string;
  updater: (item: TItem) => TItem;
}

export const updateInListCache = <TItem extends ItemWithId>({
  old,
  id,
  updater,
}: UpdateInListCacheParams<TItem>) => {
  if (!old?.items) return old;

  return {
    ...old,
    items: old?.items.map(item => (item.id === id ? updater(item) : item)),
  };
};

export const touchesDocumentNumberRangeFields = (
  queryClient: QueryClient,
  organizationId: string,
  variables: UpdateDocumentDto | BulkUpdateDocumentDto
) => {
  const maxValues = queryClient.getQueryData<DocumentColumnMaxValuesDto>([
    QueryKey.Resource.DocumentColumnMaxValues,
    organizationId,
  ]);
  const keys = maxValues
    ? (Object.keys(maxValues) as (keyof DocumentColumnMaxValuesDto)[])
    : [];

  if (keys.length === 0) return true;

  return keys.some(key => key in variables);
};
